import * as Headless from '@headlessui/react';
import React, { forwardRef } from 'react';
import { Link as RouterLink, type LinkProps as RouterLinkProps } from 'react-router-dom';

export const Link = forwardRef(function Link(
  props: { href: string } & Omit<RouterLinkProps, 'to'> & React.ComponentPropsWithoutRef<'a'>,
  ref: React.ForwardedRef<HTMLAnchorElement>
) {
  const { href, ...rest } = props;

  // Use regular <a> for external links and hash links
  if (href.startsWith('http') || href.startsWith('#') || href.startsWith('mailto:')) {
    return (
      <Headless.DataInteractive>
        {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
        <a href={href} ref={ref} {...rest} />
      </Headless.DataInteractive>
    );
  }

  return (
    <Headless.DataInteractive>
      <RouterLink to={href} ref={ref} {...rest} />
    </Headless.DataInteractive>
  );
});
